import { useCallback } from 'react'

import { stopPropagation } from '../../../../utils/events'

export function useSelectOpenState({
  allowOpen = true,
  blocked,
  disabled,
  setOpen,
  onClose,
  onOpen,
}) {
  const handleClose = useCallback(
    event => {
      stopPropagation(event)

      onClose?.()

      setOpen(false)
    },
    [onClose]
  )

  const handleOpen = useCallback(
    event => {
      stopPropagation(event)

      if (allowOpen) {
        onOpen?.()

        setOpen(true)
      }
    },
    [allowOpen, onOpen]
  )

  const handleToggleOpen = useCallback(
    event => {
      stopPropagation(event)

      if (!disabled && !blocked && allowOpen) {
        setOpen(open => {
          if (!open) {
            onOpen?.()
          } else {
            onClose?.()
          }

          return !open
        })
      }
    },
    [allowOpen, blocked, disabled, onClose, onOpen]
  )

  return {
    handleClose,
    handleOpen,
    handleToggleOpen,
  }
}
